import { Dispatch, MutableRefObject, useEffect, useRef, useState } from 'react'

const useRefState = <T extends NonNullable<unknown>>(
  initialValue: T
): [T, MutableRefObject<T>, Dispatch<React.SetStateAction<T>>] => {
  const [state, setState] = useState(initialValue)
  const stateRef = useRef(state)
  useEffect(() => {
    stateRef.current = state
  }, [state])
  return [state, stateRef, setState]
}

export const useTimeout = (callback: () => void, delaySeconds: number) => {
  const [remainingSeconds, remainingSecondsRef, setRemainingSeconds] =
    useRefState(delaySeconds)

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (remainingSecondsRef.current === 1) {
        callback()
        clearInterval(intervalId)
      }
      setRemainingSeconds(remainingSecondsRef.current - 1)
    }, 1000)
    return () => clearInterval(intervalId)
  }, [])

  return remainingSeconds
}
